import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { ConsumableAdstxtRecord } from '../../domain/consumable-adstxt-record.model';
import { SnackBarService } from '../../services/snackbar.service';
import { Domain } from '../../domain/domain.model';
import { AdsTxtStatus } from '../../domain/adstxt-status.model';

@Component({
  selector: 'cm-adstxtdiff-records-dialog',
  templateUrl: 'adstxt-missing-records-dialog.component.html',
  styles: [`
    ::ng-deep mat-tab-header.mat-tab-header {
      margin-bottom: 0.5rem;
    }

    ::ng-deep .mat-tab-body-content {
      max-height: 50vh;
    }

    ::ng-deep mat-tab-group.mat-tab-group {
      margin: 0 -24px;
    }
  `]
})
export class AdstxtMissingRecordsDialogComponent implements OnInit {
  selectedTabIndex = 0;
  adsTxtDiff: AdsTxtDiff;
  domain: Domain;
  AdsTxtStatus = AdsTxtStatus;

  missingRecordsMap: {};
  missingConsumableRecords: ConsumableAdstxtRecord[] = [];
  missingDps = [];

  recentlyAddedConsumableRecords: ConsumableAdstxtRecord[] = [];
  recentlyAddedRecordsMap: {};
  recentlyAddedDps = [];

  recentlyRemovedConsumableRecords: ConsumableAdstxtRecord[] = [];
  recentlyRemovedRecordsMap: {};
  recentlyRemovedDps = [];

  constructor(public dialogRef: MatDialogRef<AdstxtMissingRecordsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private snackBarService: SnackBarService,
              private clipboardService: ClipboardService) {
    this.domain = data.domain;

    if (!data.result) {
      alert('No data');
    } else {
      this.setData(data.result);
    }
  }

  ngOnInit() {
  }

  setData(next: AdsTxtDiff) {
    this.adsTxtDiff = next;
    // missing
    this.missingConsumableRecords = next.notFound.filter(record => record.domain.includes('consumable.com'));
    this.missingRecordsMap = this.groupDataByDemandPartner(next.notFound.filter(record => !record.domain.includes('consumable.com')));
    this.missingDps = Object.keys(this.missingRecordsMap);
    // recently added
    this.recentlyAddedConsumableRecords = next.recentlyAdded.filter(record => record.domain.includes('consumable.com'));
    this.recentlyAddedRecordsMap = this.groupDataByDemandPartner(next.recentlyAdded.filter(record => !record.domain.includes('consumable.com')));
    this.recentlyAddedDps = Object.keys(this.recentlyAddedRecordsMap);
    // recently removed
    this.recentlyRemovedConsumableRecords = next.recentlyRemoved.filter(record => record.domain.includes('consumable.com'));
    this.recentlyRemovedRecordsMap = this.groupDataByDemandPartner(next.recentlyRemoved.filter(record => !record.domain.includes('consumable.com')));
    this.recentlyRemovedDps = Object.keys(this.recentlyRemovedRecordsMap);
  }

  groupDataByDemandPartner(data: ConsumableAdstxtRecord[]) {
    return data.reduce((prev, curr) => {
      if (!prev[curr.demandPartnerName]) {
        prev[curr.demandPartnerName] = [];
      }
      prev[curr.demandPartnerName].push(curr);
      return prev;
    }, {});
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onCopyToClipboard() {
    let contentToCopy = '';
    const extendContentToCopy = element => {
      let comment = '';
      if (element.comment && this.data.showComment) {
        comment = ' ' + element.comment;
      }
      contentToCopy += element.domain + ', ' + element.publisherAccountId + ', ' + element.accountType + '\n';
    };

    this.missingConsumableRecords.forEach(extendContentToCopy);

    this.missingDps.forEach(item => {
      this.missingRecordsMap[item].forEach(extendContentToCopy);
    });

    this.clipboardService.copyFromContent(contentToCopy);
    this.snackBarService.success('Copied to clipboard!');
  }

}

export class AdsTxtDiff {
  found: ConsumableAdstxtRecord[];
  notFound: ConsumableAdstxtRecord[];
  recentlyAdded: ConsumableAdstxtRecord[];
  recentlyRemoved: ConsumableAdstxtRecord[];
}
